import { Component, Inject, Input, EventEmitter, Output, ViewChild } from '@angular/core';

import { BehaviorSubject, Subject, combineLatest, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

import { MultiFilterableSelectComponent } from '../../../../shared/filterable-select/components/multi-filterable-select.component';

import { UserService } from '../../../humain/user/services/user.service';
import { ParcTLR } from '../entities/parc-tlr.entity';

@Component({
	selector: 'parc-filterable-selector-for-cc',
	templateUrl: 'parc-filterable-selector.html',
})
export class ParcFilterableSelectorForCcComponent {
	parcs: ParcTLR[] = [];
	selectedParc: ParcTLR | undefined = undefined;

	getParcLabel = (parc: ParcTLR) => parc.code + ' (' + (parc.description ? parc.description : '') + ')';
	
	antenneIdSubject = new BehaviorSubject<number | null | undefined>(undefined);
	selectedParcIdSubject = new Subject<number | null | undefined>();

	constructor( //
		@Inject(UserService) private userService: UserService
	) {
		let parcsOnWhichUserIsCC$ = this.userService.getParcsOnWhichUserIsCC();
		let parcs$ = combineLatest([this.antenneIdSubject, parcsOnWhichUserIsCC$]).pipe(
			map(
				([antenneId, parcsOnWhichUserIsCC]) =>  {
					if (antenneId != null && antenneId != undefined) {
						return parcsOnWhichUserIsCC.filter($ => $.antenneId === antenneId);
					} else {
						return parcsOnWhichUserIsCC;
					}
				}
			)
		);
		
		// Une fois les parcs chargees les transmettre au sous-composant
		parcs$.subscribe(
			(parcs: ParcTLR[]) => {
				if (parcs && parcs.length) {
					parcs = parcs.filter( p => p.actif );
					parcs.sort( (p1, p2) => p1.code.localeCompare(p2.code) );
					this.parcs = parcs;
				}
			}
		);

		// Definit comment combiner les donnees sur l'ensemble des parcs connues avec un id d'parc pour fixer l'parc actuellement selectionnee 
		combineLatest([parcs$, this.selectedParcIdSubject]).subscribe(
			([parcs, parcId]) => {
				let newSelectedParc: ParcTLR | undefined = undefined; 
				if (parcId) {
					let parc = parcs.find(parc => parc.id === parcId);
					newSelectedParc = parc;
				}
				
				if (newSelectedParc != this.selectedParc) {
					this.selectedParc = newSelectedParc;
					this.onSelectedParcChange(this.selectedParc);
				}
			}
		);
	}

	@ViewChild(MultiFilterableSelectComponent) input!: MultiFilterableSelectComponent;

	@Input() id!: string;
	@Input() disabled = false;
	
	// Classes pour l'affichege
	public _mandatory: boolean = false;
	@Input() set mandatory(value: boolean | undefined) {
		if (value) {
			this._mandatory = value;
		}
	}
	get mandatory(): boolean | undefined {
		return this._mandatory;
	}
	public _labelClass: string = 'col-md-1';
	@Input() set labelClass(value: string | undefined) {
		if (value) {
			this._labelClass = value;
		}	
	}
	get labelClass(): string | undefined {
		return this._labelClass;
	}
	
	public _fieldClass: string = 'col-md-7';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}
	
	@Input() set antenneId(id: number | null | undefined) {
		this.antenneIdSubject.next(id);
	}
	
	private _selectedParcId: number | null | undefined = null;
	@Input() set selectedParcId(id: number | null | undefined) {
		this._selectedParcId = id;
		this.selectedParcIdSubject.next(id);
	}
	get selectedParcId(): number | null | undefined {
		return this._selectedParcId;
	}
	
	@Output() selectedParcIdChange = new EventEmitter<number | null>();
	
	@Output() selectedParcChange = new EventEmitter<ParcTLR | null>();
	
	onSelectedParcChange(parc: ParcTLR | null | undefined) {
		let id = parc ? parc.id : null;
		this._selectedParcId = id;
		this.selectedParcIdChange.emit(id);
		this.selectedParcChange.emit(parc);
	}
}